import {RootConverter} from '../../core/converter/root.converter';
import * as moment from 'moment-timezone';
import {MomentAdapter, MomentUtils} from '../../../shared/utils/moment.utils';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class DateConverter extends RootConverter<any, moment.Moment>{

    protected doConversion(src: any): moment.Moment {
        const dateAsMoment = MomentUtils.toMoment(src);
        return dateAsMoment;
    }
}

